<template>
  <b-modal centered noCloseOnBackdrop hide-footer v-model="visibleCheckUser">
    <template #modal-header>
      <span class="font-weight-bold">
        {{
          verifyType == "email"
            ? "ایمیل خود را تایید کنید"
            : "موبایل خود را تایید کنید"
        }}
      </span>
    </template>
    <validation-observer ref="verify" #default="{ invalid }">
      <b-form class="verify my-2" @submit.prevent="verify">
        <b-form-group v-if="verifyType == 'mobile' && step == 'one'">
          <validation-provider
            #default="{ errors }"
            name="phone"
            vid="phone"
            rules="required|notArabic|mobile"
          >
            <b-form-input
              autocomplete="on"
              id="phone"
              v-model.trim="userMobile"
              placeholder="موبایل مورد نظر را وارد کنید"
              name="phone"
              :state="errors.length > 0 ? false : null"
            />

            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group v-else-if="verifyType == 'email' && step == 'one'">
          <validation-provider
            #default="{ errors }"
            name="email"
            vid="email"
            rules="required|notArabic|email"
          >
            <b-form-input
              autocomplete="on"
              placeholder="ایمیل مورد نظر را وارد کنید"
              id="email"
              v-model.trim="userEmail"
              name="email"
              :state="errors.length > 0 ? false : null"
            />

            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group v-else-if="step == 'two'">
          <validation-provider
            #default="{ errors }"
            name="code"
            vid="code"
            rules="required|notArabic|min:6"
          >
            <b-form-input
              autocomplete="on"
              placeholder="کد مورد نظر را وارد کنید"
              id="code"
              v-model.trim="code"
              name="code"
              :state="errors.length > 0 ? false : null"
            />

            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-button
          variant="primary"
          block
          type="submit"
          class="my-1"
          :disabled="invalid"
        >
          {{ step == "one" ? "تایید" : "ارسال" }}
        </b-button>

        <b-button
          v-if="step == 'two'"
          variant="secondary"
          block
          @click="resend"
          :disabled="showResend"
        >
          <span>ارسال مجدد</span>
          <span class="mx-1">
            <vue-countdown
              :time="60000"
              @end="showResend = false"
              v-slot="{ totalSeconds }"
              >{{ totalSeconds }}
            </vue-countdown>
          </span>
        </b-button>
      </b-form>
    </validation-observer>
    <loader :loading="loading" />
  </b-modal>
</template>

<script>
import { BModal, BButton, BForm, BFormGroup, BFormInput } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  required,
  email,
  mobile,
  notArabic,
} from "@/@core/utils/validations/validations";
import Loader from "@core/components/loader/Loader.vue";
import VueCountdown from "@chenfengyuan/vue-countdown";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    VueCountdown,
    BModal,
    BModal,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    Loader,
  },
  computed: {
    verifyType: {
      get() {
        return this.$store.state.auth.verifyType;
      },
      set(val) {
        this.$store.dispatch("auth/setVerifyType", val);
      },
    },
    visibleCheckUser: {
      get() {
        return this.$store.state.auth.visibleCheckUser;
      },
      set(val) {
        this.$store.dispatch("auth/setVisibleCheckUser", val);
      },
    },
  },
  data() {
    return {
      required,
      email,
      mobile,
      notArabic,
      step: "one",
      userEmail: "",
      userMobile: "",
      code: "",
      loading: false,
      showResend: true,
    };
  },
  watch: {
    code(val) {
      this.code = this.p2e(val).toLowerCase();
    },
    userEmail(val) {
      this.userEmail = this.p2e(val).toLowerCase();
    },
    userMobile(val) {
      this.userMobile = this.p2e(val).toLowerCase();
    },
  },
  methods: {
    async resend() {
      this.loading = true;
      try {
        const { data } = await this.$http.post(
          `/panel/profile/${this.verifyType}/resend`,
          {
            [this.verifyType]:
              this[this.verifyType == "email" ? "userEmail" : "userMobile"],
          }
        );
        this.showResend = false;
        this.$toast({
          component: ToastificationContent,
          position: "bottom-right",
          props: {
            title: `کد با موفقیت برای شما ارسال شد.`,
            icon: "InfoIcon",
            variant: "success",
          },
        });
      } catch (err) {}
      this.loading = false;
    },
    async verify() {
      this.$refs.verify.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            if (this.step == "one") {
              const { data } = await this.$http.post(
                `/panel/profile/${this.verifyType}`,
                {
                  [this.verifyType]:
                    this[
                      this.verifyType == "email" ? "userEmail" : "userMobile"
                    ],
                }
              );
              this.$toast({
                component: ToastificationContent,
                position: "bottom-right",
                props: {
                  title:
                    this.step == "one"
                      ? `کد با موفقیت برای شما ارسال شد.`
                      : this.verifyType == "email"
                      ? "موبایل شما با موفقیت تایید شد"
                      : "ایمیل شما با موفقیت تایید شد",
                  icon: "InfoIcon",
                  variant: "success",
                },
              });
              this.step = "two";
            } else {
              const { data } = await this.$http.post(
                `/panel/profile/${this.verifyType}/verify`,
                {
                  [this.verifyType]:
                    this[
                      this.verifyType == "email" ? "userEmail" : "userMobile"
                    ],
                  code: this.code,
                }
              );
              this.$toast({
                component: ToastificationContent,
                position: "bottom-right",
                props: {
                  title:
                    this.step == "one"
                      ? `کد با موفقیت برای شما ارسال شد.`
                      : this.verifyType == "email"
                      ? "ایمیل شما با موفقیت تایید شد"
                      : "موبایل شما با موفقیت تایید شد",
                  icon: "InfoIcon",
                  variant: "success",
                },
              });
              this.visibleCheckUser = false;
            }
          } catch (err) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style></style>
